import { Component, EventEmitter,  Inject, Input, Output, OnInit} from 'ng-metadata/core';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";

const get= require('lodash/get');

let emptyArray = [];

@Component({
    "selector": "prm-search-result-journal-indication-line",
    templateUrl: 'components/search/searchResult/searchResultJournalIndication/searchResultJournalIndicationLine.html'
})

export class PrmSearchResultJournalIndicationLine implements OnInit{

    private journalLineIcons: Object[];

    @Input() private item: any;
    constructor(@Inject('journalLineIcons') journalLineIcons) {
        this.journalLineIcons = journalLineIcons;
    }

   isOpenaccess(){
        return ( get(this.item,'pnx.display.oa[0]') === 'free_for_read' || get(this.item,'pnx.addata.openaccess[0]') === 'true');
    }

    isPeerreviewed(){
         return (get(this.item, 'pnx.display.lds50[0]') === 'peer_reviewed' || get(this.item, 'pnx.addata.peerreview[0]') === 'true');
    }

    isCourseDocument() {
        return get(this.item, 'pnx.display.crsinfo[0]');
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultJournalIndication/searchResultJournalIndicationLine.directive.ts